module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-wapper flex flex-between"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {}, [_c('router-link', {
    staticClass: "white-btn flex flex-center",
    attrs: {
      "to": "index/resume/list"
    }
  }, [_vm._v("\n                    我要招人\n                    "), _c('img', {
    attrs: {
      "src": require("../../assets/images/index/user_icon.png")
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 5000,
      "arrow": "always",
      "height": "644px"
    }
  }, _vm._l((_vm.bannerList), function(item) {
    return _c('el-carousel-item', {
      key: item.id
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "notice"
  }, [_c('div', {
    staticClass: "notice-wapper flex"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "notice-list flex-grow flex"
  }, _vm._l((_vm.noticeList), function(item) {
    return _c('router-link', {
      key: item.id,
      staticClass: "notice-item flex flex-between",
      attrs: {
        "to": {
          path: '/index/home/notice/detail',
          query: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "in-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "notice-time"
    }, [_vm._v(_vm._s(item.createdAt.split(' ')[0]))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-wapper"
  }, [_c('div', {
    staticClass: "cont-title"
  }, [_vm._v("名企招聘")]), _vm._v(" "), _c('div', {
    staticClass: "famous-list flex flex-wrap"
  }, [_vm._l((_vm.famousList), function(item, index) {
    return [_c('div', {
      key: item.id + index,
      staticClass: "famous-item",
      on: {
        "mouseenter": function($event) {
          _vm.handleChange(index, 'mouseenter')
        },
        "mouseleave": function($event) {
          _vm.handleChange(null, '')
        }
      }
    }, [(_vm.famousActive === index && _vm.methods === 'mouseenter') ? _c('div', {
      staticClass: "hover"
    }, [_vm._l((item.recruitList), function(resume, i) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (i < 2),
          expression: "i < 2"
        }],
        key: 'resume' + i,
        staticClass: "resume-item flex flex-between"
      }, [_c('div', {
        staticClass: "resume-name flex"
      }, [_vm._v(_vm._s(resume.positionName))]), _vm._v(" "), _c('div', {
        staticClass: "resume-pay"
      }, [_vm._v(_vm._s(resume.minSalary) + "-" + _vm._s(resume.maxSalary) + "/月")])])
    }), _vm._v(" "), _c('div', {
      staticClass: "more flex flex-center",
      on: {
        "click": function($event) {
          _vm.handleChange(index, 'click')
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/images/index/file_search_icon.png")
      }
    }), _vm._v("\n                                查看岗位详情\n                            ")])], 2) : (_vm.famousActive === index && _vm.methods === 'click') ? _c('div', {
      staticClass: "click-show"
    }, [_c('div', {
      staticClass: "qr-title"
    }, [_vm._v("扫描二维码查看企业")]), _vm._v(" "), _c('div', {
      staticClass: "qr-img"
    }), _vm._v(" "), _c('div', {
      staticClass: "qr-desc flex-grow"
    }, [_vm._v("找工作就来在他乡小程序")])]) : _c('div', {
      staticClass: "default"
    }, [_c('div', {
      staticClass: "famous-logo"
    }, [_c('img', {
      attrs: {
        "src": item.companyLogo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "famous-name"
    }, [_vm._v(_vm._s(item.companyName))]), _vm._v(" "), _c('div', {
      staticClass: "famous-desc"
    }, [_c('span', [_vm._v(_vm._s(item.recruitList.length))]), _vm._v("个热招岗位")])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("优质企业")]), _vm._v(" "), _c('div', {
    staticClass: "quality-list flex flex-wrap"
  }, _vm._l((_vm.qualityList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "quality-item"
    }, [_c('img', {
      attrs: {
        "src": item.companyLogo
      }
    })])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo flex align-end"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/index/logo.png")
    }
  }), _vm._v("\n                蓝领人力资源服务平台\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice-title flex"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/index/notice_icon.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("公告通知")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b46ed7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/outerIndex.vue
// module id = 859
// module chunks = 1